module.exports = __webpack_public_path__ + "static/img/bg-fr.e49f36b0.png";